import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

/**
 * Automatically scrolls the window to the top whenever the route changes
 * or when the user navigates via the browser's history (back/forward).
 * It also disables the browser's native scroll restoration so that
 * previous scroll positions are not retained after navigation.
 */
export const useScrollToTopOnNavigation = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const handlePopState = () => {
      window.scrollTo(0, 0);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      const previous = window.history.scrollRestoration;
      window.history.scrollRestoration = 'manual';
      return () => {
        window.history.scrollRestoration = previous;
      };
    }
    return undefined;
  }, []);
};
